import equaliseProductHeights from './equalise-product-heights';
import filters from './filters';
import moreDeals from './more-deals';
import removeEmptyTags from './remove-empty-deal-tags';
import fixDealTagsDuplicateModals from './fix-deal-tags-duplicate-modals';

equaliseProductHeights();
filters();
moreDeals();
removeEmptyTags();
fixDealTagsDuplicateModals();
